import { BASE_URL } from '../../../configs'
import { createJsonHeaders, logoutOnRequestOrResponseJson } from '../../../api'

const activationUrl = (botId, query = '') =>
  `${BASE_URL}/bot/${botId}/qcs-activation${query}`

/**
 * QCS bot activation — raw JSON `{ botActivated }` (no message/data envelope).
 * Requires ROLE_ADMIN on the bot.
 */
export function getQcsActivation(botId, signal) {
  return fetch(activationUrl(botId), {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'GET',
    signal,
  }).then(response => {
    if (response.status === 404) {
      const err = new Error('Bot not found.')
      err.status = 404
      throw err
    }
    return logoutOnRequestOrResponseJson(response)
  })
}

/**
 * Activate or deactivate QCS for a bot.
 * POST /bot/{botId}/qcs-activation?activated=true|false
 */
export function setQcsActivation(botId, activated) {
  const query = `?activated=${activated ? 'true' : 'false'}`
  return fetch(activationUrl(botId, query), {
    credentials: 'include',
    headers: createJsonHeaders(),
    method: 'POST',
  }).then(response => {
    if (response.status === 404) {
      const err = new Error('Bot not found.')
      err.status = 404
      throw err
    }
    return logoutOnRequestOrResponseJson(response)
  })
}
